import React, { useEffect, useState } from 'react';

const BingBackground = () => {
  const [backgroundImage, setBackgroundImage] = useState('');

  useEffect(() => {
    const fetchBingImage = async () => {
      try {
        // 方法1: 使用支持CORS的代理服务
        const proxyUrl = 'https://api.allorigins.win/raw?url=';
        const bingApiUrl = 'https://cn.bing.com/HPImageArchive.aspx?format=js&idx=0&n=1';
        const response = await fetch(proxyUrl + encodeURIComponent(bingApiUrl));
        const data = await response.json();
        
        if (data.images && data.images.length > 0) {
          const imageUrl = `https://cn.bing.com${data.images[0].url}`;
          setBackgroundImage(imageUrl);
          
          // 设置到body元素
          document.body.style.backgroundImage = `url(${imageUrl})`;
          document.body.classList.add('bing-background');
          
          // 同时设置到html元素作为备用
          document.documentElement.style.backgroundImage = `url(${imageUrl})`;
          document.documentElement.classList.add('bing-background');
          
          console.log('Bing每日一图设置成功:', imageUrl);
          return;
        }
      } catch (error) {
        console.error('方法1获取Bing每日一图失败:', error);
      }

      try {
        // 方法2: 使用备用的图片API
        const response = await fetch('https://picsum.photos/1920/1080?random=' + Date.now());
        if (response.ok) {
          const imageUrl = response.url;
          setBackgroundImage(imageUrl);
          
          document.body.style.backgroundImage = `url(${imageUrl})`;
          document.body.classList.add('bing-background');
          document.documentElement.style.backgroundImage = `url(${imageUrl})`;
          document.documentElement.classList.add('bing-background');
          
          console.log('备用图片API设置成功:', imageUrl);
          return;
        }
      } catch (error) {
        console.error('方法2获取图片失败:', error);
      }

      // 如果所有方法都失败，使用默认渐变背景
      console.log('所有方法失败，使用默认渐变背景');
      document.body.style.background = 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)';
      document.documentElement.style.background = 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)';
    };

    fetchBingImage();
  }, []);

  return null; // 这个组件不渲染任何内容，只负责设置背景
};

export default BingBackground;
